import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .spinner {
        position: absolute;
        right: 25px;
        top: 24px;
        background-color: transparent;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;
        @media(max-width: 360px) {
            top: 24px;
            right: 47%;
        }
    }

    p {
        margin: 0;
        line-height: 2;
    }

    .div-input {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-disabled {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-focado {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-error {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-bottom: 8px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .botao-inside {
        display: flex;
        width: 100%;

        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }

        .salvar-branco {
            /* margin-bottom: -56px;  */
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }
    }

    .botao {
        display: flex;
        padding: 56px 32px;

        @media(max-width: 360px) {
            padding: 56px 0px;
            align-items: center;
            justify-content: center;
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }

            @media(max-width: 360px) {
                margin-top: 40px;
                width: 90%;
            }
        }

        .salvar-branco {
            margin-bottom: -56px; 
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 90%;
            }
        }
    }
        .linha-bairro {
            border-left: none;
            border-top: 1px solid #f3f3f3;
            margin: 40px 32px;

            @media(max-width: 360px) {
                margin: 56px 0px;
            }
        }

        .linha-titulo {
            border-left: none;
            border-top: 1px solid #f3f3f3;
            margin: 72px 32px;

            @media(max-width: 691px) {
                margin: 56px 0px;
            }
        }

        .linha {
            border-left: none;
            border-top: 1px solid #f3f3f3;
            margin: 56px 32px;

            @media(max-width: 360px) {
                margin: 56px 0px;
            }
        }

        .linha-distancia {
            border-left: none;
            border-top: 1px solid #f3f3f3;
            margin: 56px 0;
        }

        h2 {
                margin-bottom: 24px;
                margin-top: 0;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-bottom: 24px;
                }
            }

    .div-pai {
        margin: 32px;
        padding-bottom: 2rem;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
        }

        @media (max-width: 690px) {
            margin-top: 161px;
        }

        @media(max-width: 360px) {
            margin: 24px;
            margin-top: 153px;
            margin-bottom: 80px;
        }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 360px) {
                margin-left: 16px
            }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 360px) {
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                font-size: 24px;
            }
        }

        h5 {
            padding-right: 42px;
            margin-bottom: 56px;   
            margin-top: 0;        
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 360px) {
                margin-bottom: 24px;   
            }
        }

        h4 {
            margin-top: 64px;
            margin-bottom: 40px;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                margin-top: 40px;
                margin-bottom: 24px;
            }
        }

        .titulo {
            padding: 0 32px;

            @media(max-width: 360px) {
                padding: 0 16px;
            }
        }

        .taxa-entrega {
        display: flex;
        flex-direction: column;
        padding: 0 32px;

            @media(max-width: 360px) {
                margin-bottom: -56px;
                padding: 0 16px;
            }

            .bairros {
                margin: 40px -32px;

                @media (max-width: 691px) {
                    margin: 40px 0px;
                }

                .ordem-alfabetica {
                    padding: 32px 0px;
                    padding-left: 32px;
                    margin-right: -32px;
                    align-items: center;
                    justify-content: center;

                    hr {
                        margin: 0 -32px;
                        padding: 0;
                        border: 1.5px solid #f3f3f3;
                        @media (max-width: 360px) {
                            margin: 0 -16px;
                        }
                    }

                    @media (max-width: 691px) {
                        padding-left: 16px;
                        padding: 32px 0px;
                        margin-right: 0px;
                    }

                    .letra { 
                        font-family: Montserrat;
                        font-size: 24px;
                        color: #000000;
                        font-weight: 700;
                    }

                    .aberto-fechado {
                        cursor: pointer;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        h4 {
                            margin: 0;
                            margin-left: 16px;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 16px;
                            font-weight: 600;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2a0709
                        }
                    }

                    .div__mobile__over {

                        hr {
                            margin: 0 -32px;
                            padding: 0;
                            border: 1.5px solid #f3f3f3;

                            @media (max-width: 360px) {
                                margin: 0 -16px;
                            }
                        }

                        .div__mobile {
                            display: flex;
                            
                            flex-direction: column;
                            cursor: pointer;
                            padding-top: 32px;
                            padding-bottom: 0;
                            margin-left: -32px;
                            padding-left: 32px;
                            margin-right: -32px;
                            padding-right: 32px;

                            @media (max-width: 360px) {
                                margin-left: -16px;
                                padding-left: 16px;
                                margin-right: -16px;
                                padding-right: 16px;
                            }

                            :hover {
                                background-color: #faf8f9;
                            }

                            .head {
                                font-family: Montserrat;
                                font-size: 16px;
                                color: #a49b9b;
                                font-weight: normal;
                            }

                            .body-div {
                                margin-top: 16px;
                                margin-bottom: 32px;
                            }

                            .body {
                                font-family: Montserrat;
                                font-size: 16px;
                                color: #2a0709;
                                font-weight: normal;
                            }

                        }
                    }

                    table {
                        width: 100%;
                        margin: 0 -32px;
                        font-family: Montserrat;
                        text-align: left;
                        font-size: 16px;
                        border: none;
                        border-collapse: collapse;

                        td {
                            color: #2a0709;
                            width: 33%;
                            padding: 44px 0;
                            padding-left: 32px;
                            padding-right: -32px;
                            border: none;
                            border-bottom: 2px solid #f3f3f3;
                        }

                        th {
                            width: 33%;
                            font-weight: normal;
                            padding: 40px 0;
                            padding-left: 32px;
                            padding-right: -32px;
                            border: none;
                            border-bottom: 2px solid #f3f3f3;
                        }

                        thead {
                            color: #a49b9b;
                        }

                        tbody {

                            tr {
                                cursor: pointer;

                                :hover {
                                    background-color: #faf8f9
                                }
                            }
                        }
                }
            }
            
        }

            .options  {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;

                @media(max-width: 360px) {
                    width: 100%
                }

                .option {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 360px) {
                        padding: 6px 14px;
                    }

                    @media(max-width: 784px) {
                        padding: 12px 24px;
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #2a0709;

                        @media(max-width: 360px) {
                            font-size: 13px;
                        }
                    }
                }

                .option-selected {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    background-color: #2a0709;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 360px) {
                        padding: 6px 14px;
                    }

                    @media(max-width: 784px) {
                        padding: 12px 24px;
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #fff;

                        @media(max-width: 360px) {
                            font-size: 13px;
                        }
                    }
                }
            }
        }
    }
`

export const Filtro = styled.div`
            display: flex;
            flex-direction: column;
            width: 88%;

            @media(max-width: 360px) {
                width: 100%;
            }

            .box {
                cursor: pointer;
                border: 1.5px solid #ececec;
                border-radius: 100px;
                width: 252px;
                height: 64px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                @media (max-width: 360px) {
                    width: 88%;
                    height: 56px;
                    align-self: center;
                }

                :hover{
                    background-color: #ececec
                }

                .left {
                    display: flex;
                    flex-direction: row;
                    padding-left: 16px;
                    align-items: center;

                    h5 {
                        margin: 0;
                        padding: 0 16px;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                    }
                }

                .chevron {
                    padding-right: 32px;
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }

            .textos {
                max-width: 620px;
                /* margin-left: 32px; */
                margin-right: 16px;
                margin-top: 32px;
                transition: opacity 0.2s ease-in-out;
                -webkit-transition: opacity 0.2s ease-in-out;
                -moz-transition: opacity 0.2s ease-in-out;
                -ms-transition: opacity 0.2s ease-in-out;
                -o-transition: opacity 0.2s ease-in-out;

                @media (max-width: 360px) {
                    margin: 0 16px;
                    margin-top: 16px;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
`

export const Atencao = styled.div`
            display: flex;
            flex-direction: column;
            margin-left: 32px;
            width: 88%;

            @media(max-width: 691px) {
                margin-left: 0;
                width: 100%;
            }

            .box {
                border: 1.5px solid #ececec;
                border-radius: 100px;
                width: 185px;
                height: 64px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                @media (max-width: 691px) {
                    width: 88%;
                    height: 56px;
                    align-self: center;
                }

                .left {
                    display: flex;
                    flex-direction: row;
                    //padding-left: 32px;
                    align-items: center;

                    .alerta {
                        width: 24px;
                        height: 24px;
                    }

                    h5 {
                        margin: 0;
                        padding: 0 16px;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                    }
                }

                .chevron {
                    padding-right: 32px;
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }

            .textos {
                max-width: 620px;
                /* margin-left: 32px; */
                margin-right: 16px;
                margin-top: 32px;
                transition: opacity 0.2s ease-in-out;
                -webkit-transition: opacity 0.2s ease-in-out;
                -moz-transition: opacity 0.2s ease-in-out;
                -ms-transition: opacity 0.2s ease-in-out;
                -o-transition: opacity 0.2s ease-in-out;

                @media (max-width: 691px) {
                    display:none;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
            .textos-mobile {
                display: none;

                @media (max-width: 691px) {
                    display: flex;
                    margin: 0 16px;
                    margin-top: 16px;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
`

export const DivAccordion = styled.div`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .icon {
                width: 24px;
                height: 24px;
                padding: 0 16px;

                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
`

export const DivAlphabet = styled.div`

            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .icon {
                width: 24px;
                height: 24px;
                padding: 0 16px;

                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
`